"use client"

import { useLocale, useTranslations } from "next-intl"
import React from "react"

import { useSigninModal } from "../../../../../SignIn"
import { HeaderUserInfo } from "../../../../interface"
import { LanguageSelector } from "../../../LanguageSelector"
import { UserProfile } from "../../../UserProfile"

interface TopUtilityBarClientProps {
  userInfo: HeaderUserInfo | null
}

/**
 * 顶部工具导航栏 - 客户端组件
 * 处理用户交互：登录按钮、用户信息、语言切换
 */
export const TopUtilityBarClient: React.FC<TopUtilityBarClientProps> = ({ userInfo }) => {
  const t = useTranslations("HeaderComp")
  const { showSignInModal } = useSigninModal()
  const locale = useLocale()

  const showLoginModal = () => {
    showSignInModal({
      language: locale,
      onLoginSuccess: () => {
        window.location.reload()
      },
      onRegisterSuccess: () => {
        window.location.reload()
      },
    })
  }

  return (
    <div className="topUtilityBarRight">
      <div className="userActionsSection">
        {userInfo ? (
          <UserProfile userInfo={userInfo} />
        ) : (
          <button type="button" onClick={showLoginModal} className="signInButton">
            {t("common.SignIn")}
          </button>
        )}
        <div className="dividerLine" />
        <LanguageSelector />
      </div>
    </div>
  )
}
